import { logger } from './logger';

const BASE_URL = window.location.origin;
const API_KEY = import.meta.env.VITE_OPENAI_API_KEY;

const openaiClient = {
  async request(method, path, body = null) {
    const url = `${BASE_URL}/api/openai${path}`;
    
    const headers = {
      'Content-Type': 'application/json'
    };

    // For client-side testing, we can use the API key if provided
    // But for production, it should be handled by Cloudflare Functions
    if (API_KEY) {
      headers['Authorization'] = `Bearer ${API_KEY}`;
    }

    const requestData = {
      headers: { ...headers, Authorization: headers.Authorization ? '[REDACTED]' : undefined },
      body: body ? JSON.stringify(body) : null
    };

    const logEntry = logger.logRequest('openai', method, url, requestData);
    const startTime = Date.now();

    try {
      const fetchOptions = {
        method,
        headers
      };

      if ((method === 'POST' || method === 'PUT') && body) {
        fetchOptions.body = JSON.stringify(body);
      }

      const response = await fetch(url.toString(), fetchOptions);
      const duration = Date.now() - startTime;
      
      const contentType = response.headers.get('content-type') || '';
      let responseData;
      
      if (contentType.includes('application/json')) {
        responseData = await response.json();
      } else {
        responseData = await response.text();
      }

      logger.logResponse(logEntry.id, response.status, responseData, duration, {
        'content-type': contentType,
        status: response.status,
        statusText: response.statusText
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      return responseData;
    } catch (error) {
      const duration = Date.now() - startTime;
      logger.logError(logEntry.id, error, 0);
      throw error;
    }
  },

  // Convenience methods
  chat: (messages, model = 'gpt-3.5-turbo', temperature = 0.7, max_tokens = 1000) => 
    openaiClient.request('POST', '/chat', { messages, model, temperature, max_tokens }),
  
  completion: (prompt, model = 'text-davinci-003', temperature = 0.7, max_tokens = 1000) => 
    openaiClient.request('POST', '/completions', { prompt, model, temperature, max_tokens }),
  
  embedding: (input, model = 'text-embedding-ada-002') => 
    openaiClient.request('POST', '/embeddings', { input, model }),
  
  getModels: () => openaiClient.request('GET', '/models'),
  
  getSampleRequests: () => ({
    chat: {
      messages: [
        { role: 'system', content: 'You are a helpful assistant.' },
        { role: 'user', content: 'Hello, how are you?' }
      ],
      model: 'gpt-3.5-turbo',
      temperature: 0.7,
      max_tokens: 100
    },
    completion: {
      prompt: 'The quick brown fox jumps over the lazy dog.',
      model: 'text-davinci-003',
      temperature: 0.7,
      max_tokens: 100
    },
    embedding: {
      input: 'Hello world',
      model: 'text-embedding-ada-002'
    }
  })
};

export { openaiClient };